import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_4 = { class: "inline-block min-w-full py-2 sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "overflow-hidden" }
const _hoisted_6 = { class: "min-w-full text-center text-sm font-light" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-gray-700 uppercase py:0"
}
const _hoisted_8 = { class: "border-b dark:bg-gray-950 dark:border-gray-950" }
const _hoisted_9 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_12 = { class: "whitespace-nowrap px-6 py-4 font-medium" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "whitespace-nowrap px-6 py-4"
}
const _hoisted_15 = {
  key: 1,
  class: "whitespace-nowrap px-6 py-4"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 2,
  style: {"display":"flex","align-items":"center","justify-content":"center","margin-top":"5%"}
}
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { class: "overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_20 = { class: "inline-block min-w-full py-2 sm:px-6 lg:px-8" }
const _hoisted_21 = { class: "overflow-hidden" }
const _hoisted_22 = { class: "min-w-full text-center text-sm font-light" }
const _hoisted_23 = { class: "whitespace-nowrap px-6 py-4 font-medium" }
const _hoisted_24 = ["href"]

import {AltroLink, Link} from '../../../../EshJSLib/models/patient';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableRow',
  props: {
  dataPersonalLink: Array as PropType<Link[]>,
  data: Array as PropType<AltroLink[]>,
  showTableHeads: Boolean,
  isLinkPersonal: Boolean,
},
  emits: ["add-link-personal"],
  setup(__props, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isLinkPersonal == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", _hoisted_6, [
                    (__props.showTableHeads)
                      ? (_openBlock(), _createElementBlock("thead", _hoisted_7, [
                          _createElementVNode("tr", _hoisted_8, [
                            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('Nome')), 1),
                            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('Sede')), 1),
                            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('Informazioni')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (link, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "border-b dark:bg-gray-950 dark:border-gray-950"
                        }, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("a", {
                              href: link.link_sede,
                              target: "_blank",
                              class: "font-medium dark:text-blue-500 hover:underline"
                            }, _toDisplayString(link.link_name), 9, _hoisted_13)
                          ]),
                          (__props.showTableHeads)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(link.link_city), 1))
                            : _createCommentVNode("", true),
                          (__props.showTableHeads)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(link.link_informazioni), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.isLinkPersonal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "addButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-link-personal'))),
          title: _ctx.$t('Fare clic per aggiungere un nuovo collegamento personale')
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-plus",
            style: { color: '#1A576E' },
            size: "2xl"
          })
        ], 8, _hoisted_16))
      : _createCommentVNode("", true),
    (__props.isLinkPersonal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataPersonalLink, (link, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "border-b dark:bg-gray-950 dark:border-gray-950",
                          key: index
                        }, [
                          _createElementVNode("td", _hoisted_23, [
                            _createElementVNode("a", {
                              href: link.link,
                              target: "_blank",
                              class: "font-medium dark:text-blue-500 hover:underline"
                            }, _toDisplayString(link.name), 9, _hoisted_24)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})